import { Box } from '@mui/material';
import { StyleRules, WithStyles } from '@mui/styles';
import FormLabel from '@mui/material/FormLabel';
import React from 'react';
import MultipleWeeksPicker from '../CustomInput/MultipleWeeksPicker';
import GridContainer from '../Grid/GridContainer';
import ItemGrid from '../Grid/ItemGrid';

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => (WrappedComponent) => (props) => <WrappedComponent {...props} width="xs" />;

const WeekPeriodForm: React.FC<IProps> = ({ type, name, initWeekPeriod, onSelect }: IProps) => {
  return (
    <Box component="form" sx={profilPageStyle.formContainer}>
      <GridContainer>
        <ItemGrid xs={12} sm={3} sx={profilPageStyle.labelDisapear}>
          <Box>
            {type === 'college' ? 'Collège' : 'Offre'}
          </Box>
        </ItemGrid>
        <ItemGrid xs={12} sm={7}>
          <Box sx={profilPageStyle.name}>
            {name}
          </Box>
        </ItemGrid>

        <ItemGrid xs={12} sm={3}>
          <FormLabel sx={profilPageStyle.labelHorizontal}>
            Période de stage
          </FormLabel>
        </ItemGrid>
        <ItemGrid xs={12} sm={7}>
          {initWeekPeriod && (
            <MultipleWeeksPicker
              key='MultipleWeeksPicker'
              disablePast={true}
              limit={3}
              onSelect={onSelect}
              value={initWeekPeriod}
              isWeekPeriodAsked
            />
          )}
        </ItemGrid>
      </GridContainer>
    </Box>
  );
};

const profilPageStyle: StyleRules = {
  formContainer: {
    '@media (max-width: 1000px)': {
      width: '100%',
    },
    width:'900px',
    marginTop: '5vh',
  },
  labelDisapear: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  name: {
    height: '42px',
    marginBottom: '10px',
  },
  labelHorizontal: {
    width: '100%',
    paddingTop: '15px',
    color: '#000000',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 400,
    marginRight: '0',
    '@media (min-width: 992px)': {
      float: 'right',
    },
  },
};

interface IProps extends WithStyles<typeof profilPageStyle> {
  type: 'college' | 'offer';
  name: string;
  initWeekPeriod: any;
  onSelect: (periods) => void;
}

export default WeekPeriodForm;
